import React from 'react';

import {Container} from 'components';

import styles from './Filters.module.scss';
import {
  FilterProducts,
  FilterLocations,
  FilterLanguages,
  FilterIndustries,
  Search,
} from './components';

export const Filters = () => (
  <div className={styles.background}>
    <Container className={styles.wrap}>
      <div className={styles.label}>Filter by:</div>

      <div className={styles.filters}>
        <FilterProducts />
        <FilterLocations />
        <FilterLanguages />
        <FilterIndustries />
      </div>

      <div className={styles.rigth}>
        <Search />
      </div>
    </Container>
  </div>
);
